// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Services page specific styles */

/* Detailed Service Cards */
.service-card.detailed {
  padding: var(--space-xl);
  text-align: left;
}

.service-header {
  text-align: center;
  margin-bottom: var(--space-lg);
}

.service-header .icon-box {
  margin-bottom: var(--space-md);
}

.service-icon-img {
  width: 64px;
  height: 64px;
  margin-bottom: var(--space-md);
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.service-header h3 {
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--gray-900);
  margin: 0;
}

.service-description {
  color: var(--gray-600);
  margin-bottom: var(--space-lg);
  font-size: 1rem;
  line-height: 1.6;
}

.service-features {
  list-style: none;
  padding: 0;
  margin: 0 0 var(--space-lg) 0;
}

.service-features li {
  padding: var(--space-xs) 0;
  color: var(--gray-600);
  position: relative;
  padding-left: var(--space-lg);
}

.service-features li::before {
  content: '✓';
  position: absolute;
  left: 0;
  color: var(--teal);
  font-weight: bold;
  font-size: 1.1rem;
}

.service-cta {
  text-align: center;
  margin-top: var(--space-lg);
}

/* Process Grid */
.process-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: var(--space-xl);
  margin-top: var(--space-2xl);
}

.process-step {
  text-align: center;
  padding: var(--space-xl);
  background: var(--white);
  border: 1px solid var(--gray-200);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
  transition: all 0.3s ease;
}

.process-step:hover {
  transform: translateY(-5px);
  box-shadow: var(--shadow-lg);
  border-color: var(--accent-blue);
}

.step-number {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, var(--accent-blue) 0%, var(--teal) 100%);
  color: var(--white);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0 auto var(--space-md) auto;
}

.process-step h4 {
  font-size: 1.2rem;
  font-weight: 600;
  color: var(--gray-900);
  margin-bottom: var(--space-sm);
}

.process-step p {
  color: var(--gray-600);
  line-height: 1.6;
  margin: 0;
}

/* Portfolio Section */
.portfolio-section {
  background: var(--gray-50);
  padding: var(--space-2xl) 0;
}

.portfolio-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 var(--space-lg);
}

.portfolio-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(500px, 1fr));
  gap: var(--space-2xl);
  margin-top: var(--space-2xl);
}

.portfolio-item {
  background: var(--white);
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-lg);
  overflow: hidden;
  transition: all 0.3s ease;
}

.portfolio-item:hover {
  transform: translateY(-10px);
  box-shadow: var(--shadow-xl);
}

.portfolio-image {
  height: 200px;
  background: linear-gradient(135deg, var(--accent-blue) 0%, var(--teal) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.portfolio-placeholder {
  text-align: center;
  color: var(--white);
}

.portfolio-icon {
  font-size: 4rem;
  margin-bottom: var(--space-sm);
}

.portfolio-placeholder p {
  font-size: 1.2rem;
  font-weight: 600;
  margin: 0;
}

.portfolio-content {
  padding: var(--space-xl);
}

.portfolio-content h3 {
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--gray-900);
  margin-bottom: var(--space-md);
}

.portfolio-description {
  color: var(--gray-600);
  line-height: 1.6;
  margin-bottom: var(--space-lg);
}

.portfolio-tech {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-sm);
  margin-bottom: var(--space-lg);
}

.tech-tag {
  background: var(--gray-100);
  color: var(--gray-700);
  padding: var(--space-xs) var(--space-sm);
  border-radius: var(--radius-md);
  font-size: 0.875rem;
  font-weight: 500;
}

.portfolio-links {
  display: flex;
  gap: var(--space-md);
}

.portfolio-link {
  color: var(--accent-blue);
  text-decoration: none;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: var(--space-xs);
  transition: color 0.3s ease;
}

.portfolio-link:hover {
  color: var(--teal);
  text-decoration: underline;
}

/* Responsive Design */
@media (max-width: 768px) {
  .process-grid {
    grid-template-columns: 1fr;
    gap: var(--space-lg);
  }
  
  .service-card.detailed {
    padding: var(--space-lg);
  }

  .portfolio-grid {
    grid-template-columns: 1fr;
    gap: var(--space-xl);
  }

  .portfolio-content {
    padding: var(--space-lg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Services.css"],"names":[],"mappings":"AAAA,kCAAkC;;AAElC,2BAA2B;AAC3B;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,2DAA2D;EAC3D,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;EACxB,iCAAiC;EACjC,+BAA+B;EAC/B,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4EAA4E;EAC5E,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,4EAA4E;EAC5E,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,wCAAwC;EACxC,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA,sBAAsB;AACtB;EACE;IACE,0BAA0B;IAC1B,oBAAoB;EACtB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B;IAC1B,oBAAoB;EACtB;;EAEA;IACE,wBAAwB;EAC1B;AACF","sourcesContent":["/* Services page specific styles */\n\n/* Detailed Service Cards */\n.service-card.detailed {\n  padding: var(--space-xl);\n  text-align: left;\n}\n\n.service-header {\n  text-align: center;\n  margin-bottom: var(--space-lg);\n}\n\n.service-header .icon-box {\n  margin-bottom: var(--space-md);\n}\n\n.service-icon-img {\n  width: 64px;\n  height: 64px;\n  margin-bottom: var(--space-md);\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.service-header h3 {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: var(--gray-900);\n  margin: 0;\n}\n\n.service-description {\n  color: var(--gray-600);\n  margin-bottom: var(--space-lg);\n  font-size: 1rem;\n  line-height: 1.6;\n}\n\n.service-features {\n  list-style: none;\n  padding: 0;\n  margin: 0 0 var(--space-lg) 0;\n}\n\n.service-features li {\n  padding: var(--space-xs) 0;\n  color: var(--gray-600);\n  position: relative;\n  padding-left: var(--space-lg);\n}\n\n.service-features li::before {\n  content: '✓';\n  position: absolute;\n  left: 0;\n  color: var(--teal);\n  font-weight: bold;\n  font-size: 1.1rem;\n}\n\n.service-cta {\n  text-align: center;\n  margin-top: var(--space-lg);\n}\n\n/* Process Grid */\n.process-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: var(--space-xl);\n  margin-top: var(--space-2xl);\n}\n\n.process-step {\n  text-align: center;\n  padding: var(--space-xl);\n  background: var(--white);\n  border: 1px solid var(--gray-200);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-sm);\n  transition: all 0.3s ease;\n}\n\n.process-step:hover {\n  transform: translateY(-5px);\n  box-shadow: var(--shadow-lg);\n  border-color: var(--accent-blue);\n}\n\n.step-number {\n  width: 60px;\n  height: 60px;\n  background: linear-gradient(135deg, var(--accent-blue) 0%, var(--teal) 100%);\n  color: var(--white);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.5rem;\n  font-weight: 700;\n  margin: 0 auto var(--space-md) auto;\n}\n\n.process-step h4 {\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: var(--gray-900);\n  margin-bottom: var(--space-sm);\n}\n\n.process-step p {\n  color: var(--gray-600);\n  line-height: 1.6;\n  margin: 0;\n}\n\n/* Portfolio Section */\n.portfolio-section {\n  background: var(--gray-50);\n  padding: var(--space-2xl) 0;\n}\n\n.portfolio-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 var(--space-lg);\n}\n\n.portfolio-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(500px, 1fr));\n  gap: var(--space-2xl);\n  margin-top: var(--space-2xl);\n}\n\n.portfolio-item {\n  background: var(--white);\n  border-radius: var(--radius-xl);\n  box-shadow: var(--shadow-lg);\n  overflow: hidden;\n  transition: all 0.3s ease;\n}\n\n.portfolio-item:hover {\n  transform: translateY(-10px);\n  box-shadow: var(--shadow-xl);\n}\n\n.portfolio-image {\n  height: 200px;\n  background: linear-gradient(135deg, var(--accent-blue) 0%, var(--teal) 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n}\n\n.portfolio-placeholder {\n  text-align: center;\n  color: var(--white);\n}\n\n.portfolio-icon {\n  font-size: 4rem;\n  margin-bottom: var(--space-sm);\n}\n\n.portfolio-placeholder p {\n  font-size: 1.2rem;\n  font-weight: 600;\n  margin: 0;\n}\n\n.portfolio-content {\n  padding: var(--space-xl);\n}\n\n.portfolio-content h3 {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: var(--gray-900);\n  margin-bottom: var(--space-md);\n}\n\n.portfolio-description {\n  color: var(--gray-600);\n  line-height: 1.6;\n  margin-bottom: var(--space-lg);\n}\n\n.portfolio-tech {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--space-sm);\n  margin-bottom: var(--space-lg);\n}\n\n.tech-tag {\n  background: var(--gray-100);\n  color: var(--gray-700);\n  padding: var(--space-xs) var(--space-sm);\n  border-radius: var(--radius-md);\n  font-size: 0.875rem;\n  font-weight: 500;\n}\n\n.portfolio-links {\n  display: flex;\n  gap: var(--space-md);\n}\n\n.portfolio-link {\n  color: var(--accent-blue);\n  text-decoration: none;\n  font-weight: 600;\n  display: inline-flex;\n  align-items: center;\n  gap: var(--space-xs);\n  transition: color 0.3s ease;\n}\n\n.portfolio-link:hover {\n  color: var(--teal);\n  text-decoration: underline;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .process-grid {\n    grid-template-columns: 1fr;\n    gap: var(--space-lg);\n  }\n  \n  .service-card.detailed {\n    padding: var(--space-lg);\n  }\n\n  .portfolio-grid {\n    grid-template-columns: 1fr;\n    gap: var(--space-xl);\n  }\n\n  .portfolio-content {\n    padding: var(--space-lg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
